import { createFromJS } from "../../../types";
import rawData from "./gregorianCalendarRaw";
import oldRawData from "./gregorianCalendarRawOld";

export const createGregorianCalendar = () => {
  return createFromJS.CalendarRecord(rawData);
};

// For testing only
export const createOldGregorianCalendar = () => {
  return createFromJS.CalendarRecord(oldRawData);
};

export const isGregorianLeapYearsFromCalendar = calendar =>
  calendar.leapCycles.size === 3 &&
  calendar.leapCycles.get(0) === 4 &&
  calendar.leapCycles.get(1) === 100 &&
  calendar.leapCycles.get(2) === 400;

export const isGregorianErasFromCalendar = calendar =>
  calendar.eras.size === 2 &&
  // calendar.eras.get(0).leapOffset === 0 &&
  // calendar.eras.get(0).hasLeapYears === false &&
  calendar.eras.get(0).leapOffset === 1 &&
  calendar.eras.get(0).hasLeapYears === true &&
  calendar.eras.get(1).leapOffset === 0 &&
  calendar.eras.get(1).hasLeapYears === true;

export const isGregorianMonthsFromCalendar = calendar => {
  const months = calendar.get("months");
  if (months.count() !== 12) return false;
  if (months.get(0).normalDuration !== 31 || months.get(0).leapDuration !== 31) return false;
  if (months.get(1).normalDuration !== 28 || months.get(1).leapDuration !== 29) return false;
  if (months.get(2).normalDuration !== 31 || months.get(2).leapDuration !== 31) return false;
  if (months.get(3).normalDuration !== 30 || months.get(3).leapDuration !== 30) return false;
  if (months.get(4).normalDuration !== 31 || months.get(4).leapDuration !== 31) return false;
  if (months.get(5).normalDuration !== 30 || months.get(5).leapDuration !== 30) return false;
  if (months.get(6).normalDuration !== 31 || months.get(6).leapDuration !== 31) return false;
  if (months.get(7).normalDuration !== 31 || months.get(7).leapDuration !== 31) return false;
  if (months.get(8).normalDuration !== 30 || months.get(8).leapDuration !== 30) return false;
  if (months.get(9).normalDuration !== 31 || months.get(9).leapDuration !== 31) return false;
  if (months.get(10).normalDuration !== 30 || months.get(10).leapDuration !== 30) return false;
  if (months.get(11).normalDuration !== 31 || months.get(11).leapDuration !== 31) return false;
  return true;
};

export const isGregorianCalendarFromCalendar = calendar =>
  isGregorianMonthsFromCalendar(calendar) &&
  isGregorianLeapYearsFromCalendar(calendar) &&
  isGregorianErasFromCalendar(calendar) &&
  calendar.weekdays.size === 7 &&
  calendar.hoursInDay === 24;

const wasOldStyleGregorianErasFromCalendar = calendar =>
  calendar.eras.size === 2 &&
  calendar.eras.get(0).leapOffset === 0 &&
  calendar.eras.get(0).hasLeapYears === false &&
  calendar.eras.get(1).leapOffset === 0 &&
  calendar.eras.get(1).hasLeapYears === true;

export const wasOldStyleGregorianCalendarFromCalendar = calendar =>
  isGregorianMonthsFromCalendar(calendar) &&
  wasOldStyleGregorianErasFromCalendar(calendar) &&
  calendar.weekdays.size === 7 &&
  calendar.hoursInDay === 24;
